export function trackPageView(path: string) {
  // This is a placeholder for actual analytics implementation
  console.log(`Page view: ${path}`);
}

export function trackEvent(eventName: string, properties?: Record<string, any>) {
  // This is a placeholder for actual analytics implementation
  console.log(`Event: ${eventName}`, properties);
}